import isEqual from "fast-deep-equal";
var ref;
var getStorage = function() {
    return JSON.parse((ref = localStorage.getItem("debugBar-overloaded")) !== null && ref !== void 0 ? ref : "{}");
};
var resetStorage = function() {
    localStorage.removeItem("debugBar-overloaded");
};
var setStorage = function(storeOverloaded) {
    localStorage.setItem("debugBar-overloaded", JSON.stringify(storeOverloaded));
};
var getByKey = function(key) {
    var storeOverloaded = getStorage();
    return storeOverloaded[key];
};
var isKeyActive = function(store, key) {
    var storeOverloaded = getStorage();
    if (storeOverloaded[key] === undefined) {
        return false;
    }
    return !isEqual(store[key], storeOverloaded[key]);
};
var resetByKey = function(key) {
    var storeOverloaded = getStorage();
    storeOverloaded[key] = undefined;
    setStorage(storeOverloaded);
};
export var StoreOverloaded = {
    get: getStorage,
    getByKey: getByKey,
    isKeyActive: isKeyActive,
    reset: resetStorage,
    resetByKey: resetByKey,
    set: setStorage
};

//# sourceMappingURL=StoreOverloaded.js.map